import { SortControl } from "components/controls";

import "./ViewControl.scss";

const SORT_OPTIONS = {
  subscribers: "Subscribers",
  posts: "Posts",
};

export const ViewControl = (props: {
  order: string;
  onSortChange: (mode: string) => void;
  isNiche?: boolean;
}): JSX.Element => {
  return (
    <div className="viewControl">
      <SortControl
        order={props.order}
        options={SORT_OPTIONS}
        onChange={props.onSortChange}
        isNiche={props.isNiche}
      />
    </div>
  );
};
